import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Store, 
  MapPin, 
  Clock, 
  CreditCard, 
  Truck, 
  Palette 
} from 'lucide-react';

const TABS = [
  { id: 'basic', icon: Store, color: 'blue' },
  { id: 'location', icon: MapPin, color: 'green' },
  { id: 'operations', icon: Clock, color: 'purple' },
  { id: 'payment', icon: CreditCard, color: 'indigo' },
  { id: 'delivery', icon: Truck, color: 'orange' },
  { id: 'branding', icon: Palette, color: 'pink' }
];

export default function SettingsTabs({ activeTab, onTabChange }) {
  const { t } = useTranslation();

  return (
    <div className="border-b border-gray-200 mb-8">
      <nav className="flex space-x-8 overflow-x-auto">
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          const IconComponent = tab.icon;
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex items-center gap-3 px-4 py-4 text-sm font-medium border-b-2 transition-all duration-200
                whitespace-nowrap rounded-t-lg
                ${isActive 
                  ? `border-${tab.color}-500 text-${tab.color}-600 bg-${tab.color}-50` 
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 hover:bg-gray-50'
                }
              `}
            >
              <div className={`p-1.5 rounded-lg ${
                isActive 
                  ? `bg-${tab.color}-100` 
                  : 'bg-gray-100'
              }`}>
                <IconComponent className={`w-4 h-4 ${
                  isActive 
                    ? `text-${tab.color}-600` 
                    : 'text-gray-500'
                }`} />
              </div>
              <span>{t(`settings.tabs.${tab.id}`)}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
